export enum RepaymentMethod {
  CapitalAndInterest = 1,
  InterestOnly = 2,
  InterestOnlyPartAndPart = 3,
}
